import { render, staticRenderFns } from "./CommercialDisclaimer.vue?vue&type=template&id=2e885986&"
import script from "./CommercialDisclaimer.vue?vue&type=script&lang=js&"
export * from "./CommercialDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports